namespace TabAurous.OMS {
    export namespace UserDetailsService {
        export const baseUrl = 'OMS/UserDetails';

        export declare function Create(request: Serenity.SaveRequest<UserDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UserDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UserDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UserDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CompanyUsersList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<UserDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/UserDetails/Create",
            Update = "OMS/UserDetails/Update",
            Delete = "OMS/UserDetails/Delete",
            Retrieve = "OMS/UserDetails/Retrieve",
            List = "OMS/UserDetails/List",
            CompanyUsersList = "OMS/UserDetails/CompanyUsersList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CompanyUsersList'
        ].forEach(x => {
            (<any>UserDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
